import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api } from "@/lib/api";

// Short, Italian relative-time label -- this feed is skimmed often, so exact
// timestamps matter less than "was this five minutes ago or last week".
function timeAgo(iso) {
  const diffMs = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diffMs / 60_000);
  if (min < 1) return "adesso";
  if (min < 60) return `${min} min fa`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} ${h === 1 ? "ora" : "ore"} fa`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d} ${d === 1 ? "giorno" : "giorni"} fa`;
  return new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "short" });
}

export default function ActivityTab() {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    api.get("/owner/activity").then((r) => setEntries(r.data)).catch(() => setEntries([]));
  }, []);

  return (
    <div data-testid="activity-tab">
      <div className="mb-6">
        <h2 className="font-wed text-2xl">Ultime modifiche</h2>
        <p className="text-sm text-neutral-500 mt-1">Chi ha cambiato cosa, in ordine cronologico — utile quando più persone collaborano sullo stesso matrimonio.</p>
      </div>

      {entries === null ? (
        <div className="animate-pulse font-wed text-xl py-16 text-center" style={{ color: "var(--wed-primary)" }}>Caricamento…</div>
      ) : entries.length === 0 ? (
        <div className="border border-dashed rounded-3xl py-16 text-center text-neutral-400" style={{ borderColor: "#e3ddd2" }} data-testid="activity-empty">
          Nessuna modifica registrata ancora.
        </div>
      ) : (
        <div className="bg-white border rounded-2xl divide-y" style={{ borderColor: "#e3ddd2" }} data-testid="activity-list">
          {entries.map((e) => (
            <div key={e.id} className="flex items-start gap-3 px-5 py-4" data-testid={`activity-entry-${e.id}`}>
              <div className="rounded-full p-2 shrink-0 mt-0.5" style={{ background: "color-mix(in srgb, var(--wed-primary) 15%, white)" }}>
                <History size={14} style={{ color: "var(--wed-primary)" }} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm">
                  <span className="font-medium">{e.user_name}</span> {e.description}
                </p>
                <p className="text-xs text-neutral-400 mt-0.5">{timeAgo(e.created_at)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
